__turbopack_context__.v({
  "art": "E026fa_art",
  "number": "E026fa_number",
  "text": "E026fa_text",
});
